import React from 'react'
import Sidebar from '../components/mainpage/subcomponent/Sidebar'
import '../components/styles/dashboard.css'
import Applicationsignature from '../components/mainpage/subcomponent/applicationsignature'
const MainApplication = () => {
    return (
        <div>
            <Sidebar />
            <div className='container-fluid'>
                <Applicationsignature/>
            </div>
        </div>
    )
}

export default MainApplication